import { createAsyncThunk } from '@reduxjs/toolkit';
import { PromoCode } from '../../../client/services';
import { toastHandler } from '../../../utils/toastHandler';
import { CreatePatchPromoCode, FindPromoCode, GetPromoCode } from './interface';

export const createPromoCode = createAsyncThunk(
  'promoCode/createPromoCode',
  async (values: CreatePatchPromoCode, { rejectWithValue }) => {
    try {
      const response = await PromoCode.create(values);
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const findPromoCode = createAsyncThunk('promoCode/findPromoCode', async (values: FindPromoCode, { rejectWithValue }) => {
  try {
    const response = await PromoCode.find({
      query: values,
    });

    return response;
  } catch (error: any) {
    toastHandler(error);
    return rejectWithValue(error.message);
  }
});

export const getPromoCode = createAsyncThunk(
  'promoCode/getPromoCode',
  async ({ id }: GetPromoCode, { rejectWithValue }) => {
    try {
      const response = await PromoCode.get(id);

      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const patchPromoCode = createAsyncThunk(
  'promoCode/patchPromoCode',
  async ({ id, ...values }: CreatePatchPromoCode, { rejectWithValue }) => {
    try {
      const response = await PromoCode.patch(id, values);
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);
